(window as any).SmartFormMultipleItemsDataStore=require('./SmartFormMultipleItemsDataStore').SmartFormMultipleItemsDataStore;
(window as any).SmartFormBasicDataStore=require('./SmartFormBasicDataStore').SmartFormBasicDataStore;
(window as any).SmartFormDateDataStore=require('./SmartFormDateDataStore').SmartFormDateDataStore;
(window as any).SmartFormRepeaterDataStore=require('./SmartFormRepeaterDataStore').SmartFormRepeaterDataStore;



// WEBPACK FOOTER //
// ./formBuilder/dataStores/SmartFormsDataStoreBootstrap.ts